export type dialogSizeType = { confirm: number; small: number; medium: number; large: number };

export const DIALOG_SIZE: dialogSizeType = {
  confirm: 500,
  small: 600,
  medium: 800,
  large: 1200,
};
